<div [ngClass]="{'min-height-900':slug !== corporateNavigation.CONTACT_FOREVERE_LIVING}" class="static-content" appDynamicNavigation (isNavClicked)="navigateToPortal($event)" *ngIf="contentHtml" id="static-tempate">
  <div [innerHTML]="contentHtml | safeHtml"></div>
</div>
<div *ngIf = "slug === corporateNavigation.HOME">
  <app-bestseller-products *ngFor="let catalog of customCatalogs" [catalog]="catalog" ></app-bestseller-products>
</div>
<div class="col-md-12 text-center contact-us__block" *ngIf="slug && slug===corporateNavigation.CONTACT_FOREVERE_LIVING && mapLocation && contentHtml">
  <!-- Contact Information -->
  <div class="contact__name pt-3 pb-2">{{mapLocation.name}}</div>
  <div *ngIf="mapLocation.address1">{{mapLocation.address1}},</div>
  <div *ngIf="mapLocation.address2">{{mapLocation.address2}}</div>
  <div class="py-4">
    <div *ngIf="mapLocation.emailID" class="contact__email">{{mapLocation.emailID}}</div>
    <div *ngIf="mapLocation.phone">{{mapLocation.phone}}</div>
    <div *ngIf="mapLocation.url">{{mapLocation.url}}</div>
</div>
</div>
<div *ngIf="translateParams" class="min-height-900 static-content text-center error-guid">
  {{'header.Error Occured while process your request. Please contact customer service with ID: ||errorGuid||' | translate | translateKey:translateParams}}
</div>
